if (!customElements.get('color-groups-expander')) {
  // Temporarily disabled — set to true to re-enable desktop clipping
  const CLIP_ENABLED = false;

  const _expandedGroups = new Set();

  customElements.define('color-groups-expander', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.init());
    }
    init() {
      this._resizeObserver?.disconnect();
      this._mobileQuery?.removeEventListener('change', this._onBreakpointChange);

      const container = this.querySelector('.color-groups-container');
      const btn = this.querySelector('.color-group__expand-btn');
      if (!container || !btn) return;
      this._container = container;
      this._btn = btn;
      if (this._onExpandClick) btn.removeEventListener('click', this._onExpandClick);
      this._onExpandClick = () => this.expand();
      btn.addEventListener('click', this._onExpandClick);

      // Fire clip() whenever mobile/desktop breakpoint is crossed
      this._mobileQuery = window.matchMedia('(max-width: 749px)');
      this._onBreakpointChange = () => this.clip();
      this._mobileQuery.addEventListener('change', this._onBreakpointChange);

      // Re-evaluate clipping when element width changes (e.g. viewport resize within desktop)
      this._resizeObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect?.width);
        if (width !== this._lastWidth) {
          this._lastWidth = width;
          this.clip();
        }
      });
      this._resizeObserver.observe(this);

      this.clip();
    }
    disconnectedCallback() {
      this._resizeObserver?.disconnect();
      this._mobileQuery?.removeEventListener('change', this._onBreakpointChange);
    }
    clip() {
      const container = this._container;
      const btn = this._btn;
      if (!container || !btn) return;

      // Clipping disabled — show all colors
      if (!CLIP_ENABLED) {
        container.style.maxHeight = 'none';
        container.style.overflow = '';
        btn.hidden = true;
        return;
      }

      // On mobile show all — no clipping needed
      if (this._mobileQuery.matches) {
        container.style.maxHeight = 'none';
        container.style.overflow = '';
        btn.hidden = true;
        return;
      }

      // Already expanded by user on desktop — keep expanded
      if (_expandedGroups.has(this.dataset.productId)) {
        container.style.maxHeight = 'none';
        container.style.overflow = '';
        btn.hidden = true;
        return;
      }

      // Measure first row height
      container.style.maxHeight = 'none';
      container.style.overflow = '';
      const firstLabel = container.querySelector('label.color-swatch');
      if (!firstLabel) return;
      const containerRect = container.getBoundingClientRect();
      const firstLabelRect = firstLabel.getBoundingClientRect();
      const rowHeight = firstLabelRect.bottom - containerRect.top + 4;
      container.style.maxHeight = rowHeight + 'px';
      container.style.overflow = 'hidden';

      // Auto-expand if selected radio is clipped
      const checked = container.querySelector('input[type="radio"]:checked');
      if (checked) {
        const checkedRect = checked.getBoundingClientRect();
        if (checkedRect.bottom > containerRect.top + rowHeight) {
          this.expand();
          return;
        }
      }

      btn.hidden = container.scrollHeight <= container.clientHeight + 2;
    }
    expand() {
      if (!this._container || !this._btn) return;
      this._container.style.maxHeight = 'none';
      this._btn.hidden = true;
      _expandedGroups.add(this.dataset.productId);
    }
  });
}
